import {Component, Input, OnInit} from '@angular/core';
import {Product} from '../../../../models/product';


@Component({
    selector: 'app-product-galary',
    templateUrl: './product-galary.component.html',
    styleUrls: ['./product-galary.component.css']
})
export class ProductGalaryComponent implements OnInit {
    // @Input() mainImage;
    @Input() product: Product;


    constructor() {
    }

    ngOnInit(): void {
        console.log('the product');
        console.log(this.product);
    }

}

